(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(bootstrapMaterialDesignConfig);

    compileServiceConfig.$inject = [];

    function bootstrapMaterialDesignConfig() {
        $.material.init();

    }

    function compileServiceConfig() {

    }
})();
